import AsyncPage from 'pages/AsyncPage'


import universal from 'react-universal-component'
import { PrivacyPage  } from './PrivacyPage'
export const UniversalLandingPage = universal<any, typeof PrivacyPage>(props => import('./PrivacyPage'))

class AsyncPrivacyPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: UniversalLandingPage,
      basicDataRequirements: {
        instance: true,
        session: false
      }
    })
  }
}

export default new AsyncPrivacyPage()
